
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/typing-test",
      function () {
        return require("private-next-pages/typing-test.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/typing-test"])
      });
    }
  